// src/searchMap.ts

import { companySearchMap } from "./companySearchMap";

export const searchMap: Record<string, string> = {
  // ============================
  // ANIMALS
  // ============================
  animals: "/animals",
  animal: "/animals",
  birds: "/animals/birds",
  bird: "/animals/birds",
  cats: "/animals/cats",
  cat: "/animals/cats",
  dogs: "/animals/dogs",
  dog: "/animals/dogs",

  // ============================
  // SPORTS
  // ============================
  sports: "/sports",
  sport: "/sports",
  nfl: "/sports/nfl",
  football: "/sports/nfl",
  nba: "/sports/nba",
  basketball: "/sports/nba",
  soccer: "/sports/soccer",
  futbol: "/sports/soccer",

  // ============================
  // CELEBRITIES (CATEGORY PAGES)
  // ============================
  celebrities: "/celebrities",
  celebrity: "/celebrities",
  actors: "/celebrities/actors",
  actor: "/celebrities/actors",
  musicians: "/celebrities/musicians",
  music: "/celebrities/musicians",
  influencers: "/celebrities/influencers",

  // ============================
  // CELEBRITIES — INDIVIDUAL
  // ============================

  // ⭐ Cristiano Ronaldo
  "cristiano-ronaldo": "/celebrities/cristiano-ronaldo",
  cristiano: "/celebrities/cristiano-ronaldo",
  ronaldo: "/celebrities/cristiano-ronaldo",
  "cristiano ronaldo": "/celebrities/cristiano-ronaldo",

  // ⭐ Lionel Messi
  "lionel-messi": "/celebrities/lionel-messi",
  messi: "/celebrities/lionel-messi",
  lionel: "/celebrities/lionel-messi",
  "lionel messi": "/celebrities/lionel-messi",

  // ⭐ Neymar Jr
  "neymar-jr": "/celebrities/neymar-jr",
  neymar: "/celebrities/neymar-jr",
  "neymar jr": "/celebrities/neymar-jr",

  // ⭐ Kylian Mbappé
  "kylian-mbappe": "/celebrities/kylian-mbappe",
  mbappe: "/celebrities/kylian-mbappe",
  kylian: "/celebrities/kylian-mbappe",
  "kylian mbappe": "/celebrities/kylian-mbappe",

  // ⭐ Karim Benzema
  "karim-benzema": "/celebrities/karim-benzema",
  benzema: "/celebrities/karim-benzema",
  karim: "/celebrities/karim-benzema",

  // ⭐ Erling Haaland
  "erling-haaland": "/celebrities/erling-haaland",
  haaland: "/celebrities/erling-haaland",
  erling: "/celebrities/erling-haaland",

  // ⭐ LeBron James
  "lebron-james": "/celebrities/lebron-james",
  lebron: "/celebrities/lebron-james",
  james: "/celebrities/lebron-james",
  "lebron james": "/celebrities/lebron-james",

  // ⭐ Taylor Swift
  "taylor-swift": "/celebrities/taylor-swift",
  taylor: "/celebrities/taylor-swift",
  swift: "/celebrities/taylor-swift",
  "taylor swift": "/celebrities/taylor-swift",

  // ⭐ Donald Trump
  "donald-trump": "/celebrities/donald-trump",
  donald: "/celebrities/donald-trump",
  trump: "/celebrities/donald-trump",
  "donald trump": "/celebrities/donald-trump",

  // ============================
  // NEWS
  // ============================
  news: "/news",
  worldnews: "/news/world",
  world: "/news/world",
  politics: "/news/us-politics",
  localnews: "/news/local",
  local: "/news/local",

  // ============================
  // WEATHER
  // ============================
  weather: "/weather",
  forecast: "/weather/10-day",
  "10-day": "/weather/10-day",
  alerts: "/weather/alerts",

  // ============================
  // FINANCE
  // ============================
  finance: "/finance",
  stocks: "/finance/stocks",
  crypto: "/finance/crypto",
  marketnews: "/finance/market-news",

  // ============================
  // MOVIES
  // ============================
  movies: "/movies",
  films: "/movies",
  trendingmovies: "/movies/trending",
  toprated: "/movies/top-rated",
  newmovies: "/movies/new-releases",

  // ============================
  // MUSIC
  // ============================
  musiccategory: "/music",
  topsongs: "/music/top-songs",
  artists: "/music/artists",
  albums: "/music/albums",

  // ============================
  // GAMES
  // ============================
  games: "/games",
  videogames: "/games/video-games",
  mobilegames: "/games/mobile-games",
  esports: "/games/esports",

  // ============================
  // HEALTH
  // ============================
  health: "/health",
  symptoms: "/health/symptoms",
  fitness: "/health/fitness",
  nutrition: "/health/nutrition",

  // ============================
  // TRAVEL
  // ============================
  travel: "/travel",
  flights: "/travel/flights",
  hotels: "/travel/hotels",
  destinations: "/travel/destinations",

  // ============================
  // FOOD
  // ============================
  food: "/food",
  restaurants: "/food/restaurants",
  recipes: "/food/recipes",
  fastfood: "/food/fast-food",

  // ============================
  // TECH
  // ============================
  tech: "/tech",
  ai: "/tech/ai-tools",
  phones: "/tech/phones",
  laptops: "/tech/laptops",

  // ============================
  // SHOPPING
  // ============================
  shopping: "/shopping",
  amazon: "/shopping/amazon-deals",
  walmart: "/shopping/walmart",
  target: "/shopping/target",

  // ============================
  // EDUCATION
  // ============================
  education: "/education",
  school: "/education",
  learning: "/education",
  study: "/education",

  math: "/education/math-help",
  "math help": "/education/math-help",

  language: "/education/language-learning",
  "language learning": "/education/language-learning",

  history: "/education/history",

  // ============================
  // ⭐ MERGE COMPANY SEARCH MAP
  // ============================
  ...companySearchMap,
};
